module.exports = __webpack_public_path__ + "static/media/ic-square-pixel.2ae71043.svg";